import React from "react";
import { useSelector } from "react-redux";
import { countryList } from "../../../../helperFuncs/countryList";

const SalesAgentRevenueCard = ({ data }) => {
  const { country } = useSelector((state) => state.projectSite);

  return (
    <div className="space-y-4">
      {data && data.length > 0 ? (
        data.map((item, index) => (
          <div
            key={index}
            className="bg-white p-4 rounded-lg shadow-md border border-gray-200"
          >
            <div className="grid grid-cols-2 gap-3">
              <div className="col-span-2">
                <h3 className=" font-semibold text-gray-800">{item.date}</h3>
                <div className="w-full h-[1px] bg-gray-200 my-2"></div>
              </div>

              <div>
                <p className="text-sm text-gray-500">
                  Total Revenue ({countryList[country]["Currency Code"] ?? ""})
                </p>
                <p className="font-semibold">
                  {Number(item?.totalRevenue).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) ?? 0}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">
                  Net Revenue ({countryList[country]["Currency Code"] ?? ""})
                </p>
                <p className="font-semibold">
                  {Number(item?.netRevenue).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) ?? 0}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Total KWh</p>
                <p className="font-semibold">
                  {Number(item?.totalKWh).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) ?? 0}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">
                  Total Commission (
                  {countryList[country]["Currency Code"] ?? ""})
                </p>
                <p className="font-semibold">
                  {Number(item?.totalCommission).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  }) ?? 0}
                </p>
              </div>

              <div>
                <p className="text-sm text-gray-500">Number of transactions</p>
                <p className="font-semibold">{item.transactionCount}</p>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-8 text-gray-500">No data available</div>
      )}
    </div>
  );
};

export default SalesAgentRevenueCard;
